<div class="question-container sized-wrapper">

  <div class="wrapper column gap full-width" [formGroup]="questionForm">

    <h1>{{ isPricingRequest ? 'Demander une proposition' : ('contact.title' | translate) }}</h1>

    <p *ngIf="isPricingRequest" class="request-intro">
      Pour vous envoyer la proposition adaptée, renseignez les coordonnées de l'entreprise et votre besoin.
    </p>

    <div *ngIf="isPricingRequest" class="contact-grid">
      <app-input
        title="Entreprise"
        type="organization"
        formControlName="companyName"
        placeholder="Nom de l'entreprise">
      </app-input>
      <app-input
        title="Contact"
        type="user"
        formControlName="contactName"
        placeholder="Nom et prénom">
      </app-input>
      <app-input
        title="Email professionnel"
        type="email"
        formControlName="contactEmail"
        placeholder="email@entreprise.fr">
      </app-input>
      <app-input
        title="Téléphone"
        formControlName="contactPhone"
        placeholder="Numéro de téléphone">
      </app-input>
    </div>

    <p>{{ isPricingRequest ? 'Quel est votre besoin ?' : ('contact.subjectPrompt' | translate) }}</p>
    <app-input formControlName="subject"
               [dropdownData]="subjects"
               [placeholder]="'contact.subject' | translate"></app-input>
    <textarea
      class="margin-bottom"
      formControlName="content"
      [placeholder]="isPricingRequest
        ? 'Précisez ici votre besoin, le nombre de collaborateurs, le niveau de pilotage attendu ou toute information utile.'
        : ('contact.placeholder' | translate)">
    </textarea>
    <div class="center-children">
      <app-button [disabled]="!questionForm.valid || apiCalling" (click)="sendEmail()" [title]="isPricingRequest ? 'Demander la proposition' : ('contact.send' | translate)">
        {{ isPricingRequest ? 'Demander la proposition' : ('contact.send' | translate) }}
      </app-button>
    </div>
  </div>


</div>
